import type { JSX, ReactNode } from 'react'

/**
 * *Before you start* — the three or four things a person needs to know before
 * a form or a Connect button will work for them, with a link to the full page.
 *
 * The same argument as `PublishTargets.SetupSteps` (SEO-UI-118): field help
 * answers *what goes in this box*, and this answers *where do I get it*, which is
 * the question actually being asked. It is plain content rather than a
 * `<details>` for the reason that one gives — somebody who already knows scrolls
 * past four lines; somebody who does not would never have opened it.
 *
 * Written for the Google connections first, where the prerequisite lives
 * entirely outside AugRank: the signed-in account has to already own the site in
 * Google's own tools, and nothing on the screen said so until this did.
 */
export function SetupGuide({
  title = 'Before you start',
  steps,
  href,
  linkText = 'Read the full guide',
}: {
  title?: string
  steps: readonly ReactNode[]
  /** The documentation page, opened in a new tab — it is on another origin. */
  href: string
  linkText?: string
}): JSX.Element {
  return (
    <section className="app-setup" aria-label={title}>
      <h2 className="app-setup__title">{title}</h2>
      <ol className="app-setup__steps">
        {steps.map((step, index) => (
          // Steps are static prose with no identity of their own; the index is
          // the key the way it is for any fixed list.
          <li key={index}>
            <span>{step}</span>
          </li>
        ))}
      </ol>
      <p className="app-setup__link">
        <a className="ar-link" href={href} target="_blank" rel="noreferrer noopener">
          {linkText} ↗
        </a>
      </p>
    </section>
  )
}
